import { capitalizePlatformName } from '../utils/platformNames';
import { Icon } from '../utils/icons';

const ReviewsBreakdown = ({ data, isLoading }) => {

    if (isLoading) {
        return (
            <div className="bg-white rounded-2xl border border-gray-100 p-6">
                <div className="animate-pulse">
                    <div className="h-6 bg-gray-200 rounded w-48 mb-4"></div>
                    <div className="space-y-3">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                <div className="flex items-center">
                                    <div className="w-10 h-10 bg-gray-300 rounded-lg"></div>
                                    <div className="ml-3">
                                        <div className="h-4 bg-gray-300 rounded w-24"></div>
                                        <div className="h-3 bg-gray-200 rounded w-16 mt-1"></div>
                                    </div>
                                </div>
                                <div className="h-4 bg-gray-300 rounded w-12"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    const locationReviews = data?.locationReviews || [];

    return (
        <div className="bg-white rounded-2xl border border-gray-100 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Reviews by Location & Platform
            </h3>

            {locationReviews.length === 0 ? (
                <div className="text-center py-8">
                    <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                        <Icon name="analytics" className="text-gray-400" size={32} />
                    </div>
                    <p className="text-gray-500">No reviews data available yet</p>
                    <p className="text-sm text-gray-400 mt-1">Reviews will appear here once you have data</p>
                </div>
            ) : (
                <div className="max-h-96 overflow-y-auto pr-2 custom-scrollbar">
                    <div className="space-y-4">
                        {locationReviews.map((location, index) => (
                            <div key={index} className="border border-gray-100 rounded-xl p-4">
                                <div className="flex items-center justify-between mb-3">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg flex items-center justify-center text-blue-600">
                                            <Icon name="location" size={20} />
                                        </div>
                                        <div className="ml-3">
                                            <h4 className="font-medium text-gray-900">{location.name}</h4>
                                            <p className="text-sm text-gray-500">
                                                {location.totalReviews} total reviews
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <Icon name="star" className="text-yellow-500" size={16} />
                                        <span className="ml-1 font-medium text-gray-900">{location.averageRating}</span>
                                    </div>
                                </div>

                                {location.platforms && location.platforms.length > 0 && (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3 pt-3 border-t border-gray-100">
                                        {location.platforms.map((platform, platformIndex) => (
                                            <div key={platformIndex} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                                                <div className="flex items-center">
                                                    {platform.iconUrl ? (
                                                        <img
                                                            src={platform.iconUrl}
                                                            alt={platform.name}
                                                            className="w-6 h-6 rounded"
                                                        />
                                                    ) : (
                                                        <div className="w-6 h-6 bg-gradient-to-r from-purple-400 to-pink-400 rounded flex items-center justify-center text-white text-xs">
                                                            {platform.name.charAt(0).toUpperCase()}
                                                        </div>
                                                    )}
                                                    <span className="ml-2 text-sm font-medium text-gray-700">
                                                        {capitalizePlatformName(platform.name)}
                                                    </span>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                    <span className="text-sm font-medium text-gray-900">
                                                        {platform.count}
                                                    </span>
                                                    {platform.averageRating && (
                                                        <div className="flex items-center text-xs">
                                                            <Icon name="star" className="text-yellow-500" size={12} />
                                                            <span className="ml-1 text-gray-900">{platform.averageRating}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReviewsBreakdown;
